<template lang="pug">
    header.header(:data-menu-state='isOpen ? "open" : "close"', :data-state='filterIsOpen ? "show" : "hide"', :class='{hidden: !isLoaded}')
        .header__color-filter(:data-state='filterIsOpen ? "show" : "hide"', @click='close')
        button.header__btn(@click='isOpen = !isOpen')
            span
                b
                b

        .header__logo
            router-link(to='/', @click.native='close')
                rambler-logo
                //- img.header__logo-new-year-decor(src="@/assets/img/logo/hat-new-year.png" aria-label="С Новым Годом!")
        Menu(:closed='filterIsOpen', :isOpen='isOpen' @close='close', @openFilter='setFilterState(true)', @closeFilter='setFilterState(false)')

</template>

<script>
import RamblerLogo from '@/components/RamblerLogo.vue';
import sections from '../assets/data/sections.json';

const Menu = () => import('@/components/Menu.vue');

export default {
    name: 'Header',

    data() {
        return {
            items: sections,
            isOpen: false,
            filterIsOpen: false,
            isLoaded: false
        };
    },

    mounted() {
        setTimeout(() => {
            this.isLoaded = true;
        }, 300);
    },

    components: {
        Menu,
        RamblerLogo
    },

    methods: {
        close() {
            this.isOpen = false;
            this.filterIsOpen = false;
        },
        setFilterState(state) {
            this.filterIsOpen = state;
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../assets/css/vars.scss';

:root {
    --vh: 5.68px;
    --logoColor: black;
}

.header {
    position: fixed;
    z-index: 50;
    width: 100%;
    height: 2.8em;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-left: 7.29165vw;
    background-color: transparent;
    transition: opacity 0.6s ease-out;
    opacity: 1;
    will-change: opacity;

    &.hidden {
        opacity: 0;
    }

    @media (--viewport-tablet) {
        background-color: black;
        padding-left: calc(var(--layout-gutter-width) * 2 + var(--layout-column-width));
    }

    &__btn {
        position: relative;
        display: none;
        width: var(--layout-column-width);
        height: var(--layout-column-width);
        z-index: 10;

        span {
            display: block;
            position: absolute;
            top: calc(var(--layout-column-width) / 2 - 1px);
            width: 100%;
            height: 3px;
            background-color: white;
            transition: background-color 0.3s ease;

            b {
                position: relative;
                display: block;
                width: 100%;
                height: 100%;
                background-color: white;
                top: -9px;
                left: 0;
                transition: transform 0.3s ease, background-color 0.3s ease;

                &:last-child {
                    top: 6px;
                }
            }
        }

        @media (--viewport-tablet) {
            position: absolute;
            right: 10vw;
            left: unset;
            display: block;

            .header[data-menu-state='open'] & {
                span {
                    background-color: transparent;

                    b {
                        transform-origin: 50%;
                        position: absolute;
                        top: 0;
                        left: 0;
                        background-color: var(--color-main-text);

                        &:first-child {
                            transform: rotate(45deg);
                        }

                        &:last-child {
                            transform: rotate(-45deg);
                        }
                    }
                }
            }
        }
    }

    &__logo-new-year-decor {
        position: absolute;
        height: 0.5em;
        top: -0em;
        left: -0.15em;
    }

    &__logo {
        position: relative;
        height: 1.5em;
        width: 6em;

        &--special {
            height: 1.5em;
            width: 8em;
        }

        a {
            display: block;
        }

        svg {
            height: 100%;
            width: 100%;
            transition: fill 0.3s ease;
            fill: #000;
            fill: var(--logoColor);

            path {
                fill: #000;
            }

            path.stroke {
                fill: transparent;
                stroke: #000;
            }
        }

        @media (--viewport-tablet) {
            left: 10vw;
            position: absolute;

            svg {
                fill: white;

                path {
                    fill: white;
                }

                path.stroke {
                    fill: transparent;
                    stroke: white;
                }
            }
        }
    }

    &[data-state='show'] {
        .header {
            &__logo {
                svg {
                    fill: white;

                    path {
                        fill: white;
                    }

                    path.stroke {
                        fill: transparent;
                        stroke: white;
                    }
                }
            }
        }
    }

    &__color-filter {
        position: fixed;
        width: 100%;
        top: 0;
        left: 0;
        opacity: 0;
        background-color: var(--color-header-bg);
        transition: opacity 0.3s ease;
        pointer-events: none;

        @supports (--css: variables) {
            height: calc(var(--vh) * 100);
        }

        @media (--viewport-tablet) {
            display: none;
        }

        &[data-state='show'] {
            opacity: 0.95;
            pointer-events: all;
        }
    }
}
</style>
